import { PlayerService } from '../services/playerService';
import { QueueService } from '../services/queueService';
import { INITIAL_PLAYERS } from './constants';

export class DatabaseInitializer {
  // 检查数据库是否已初始化
  static async isDatabaseInitialized(): Promise<boolean> {
    try {
      const players = await PlayerService.getAllActivePlayers();
      const queue = await QueueService.getCurrentQueue();
      
      return players.length > 0 && queue !== null;
    } catch (error) {
      console.error('检查数据库初始化状态失败:', error);
      return false;
    }
  }

  // 初始化数据库
  static async initializeDatabase(): Promise<void> {
    try {
      console.log('开始初始化数据库...');

      // 1. 初始化默认玩家
      await PlayerService.initializeDefaultPlayers();
      console.log('✅ 默认玩家初始化完成');

      // 2. 获取所有活跃玩家
      const players = await PlayerService.getAllActivePlayers();
      console.log(`✅ 获取到 ${players.length} 个活跃玩家`);

      // 3. 初始化队列状态
      const existingQueue = await QueueService.getCurrentQueue();
      if (!existingQueue) {
        await QueueService.initializeQueue(players);
        console.log('✅ 队列状态初始化完成');
      } else {
        console.log('✅ 队列状态已存在，跳过初始化');
      }

      console.log('🎉 数据库初始化完成！');
    } catch (error) {
      console.error('❌ 数据库初始化失败:', error);
      throw error;
    }
  }

  // 重置数据库（开发环境使用）
  static async resetDatabase(): Promise<void> {
    try {
      console.log('开始重置数据库...');
      
      // 注意：这里只是标记为不活跃，不是真正删除
      // 在生产环境中应该谨慎使用
      const players = await PlayerService.getAllActivePlayers();
      
      for (const player of players) {
        await PlayerService.removePlayer(player.id);
      }
      
      console.log('✅ 数据库重置完成');
      
      // 重新初始化
      await this.initializeDatabase();
    } catch (error) {
      console.error('❌ 数据库重置失败:', error);
      throw error;
    }
  }

  // 验证数据库完整性
  static async validateDatabase(): Promise<{
    isValid: boolean;
    issues: string[];
  }> {
    const issues: string[] = [];

    try {
      // 检查玩家数据
      const players = await PlayerService.getAllActivePlayers();
      if (players.length < 4) {
        issues.push(`活跃玩家数量不足：当前 ${players.length} 人，至少需要 4 人`);
      }

      // 检查编号是否重复
      const numbers = players.map(p => p.number);
      const uniqueNumbers = new Set(numbers);
      if (numbers.length !== uniqueNumbers.size) {
        issues.push('存在重复的玩家编号');
      }

      // 检查队列状态
      const queue = await QueueService.getCurrentQueue();
      if (!queue) {
        issues.push('队列状态未初始化');
      } else if (queue.players.length !== players.length) {
        issues.push('队列中的玩家数量与活跃玩家数量不匹配');
      }

      return {
        isValid: issues.length === 0,
        issues,
      };
    } catch (error) {
      issues.push(`数据库验证过程中发生错误: ${error}`);
      return {
        isValid: false,
        issues,
      };
    }
  }
}